import http from '../../../../Common/Services/HttpService';
import { SET_EMPLOYEE_PROFILE } from '../../../../Store/Slices/EmployeeProfile';
import { onLoadAPI } from '../../../../Store/Slices/Entities/response';
import appConfig from '../../../../appConfig';
import ServiceHelper from '../../../Utils/Helper/MappingHelper';
import { SET_ALERT_MESSAGE } from '../../../../Store/Slices/InsuredInfo';

export const getPersonalInformation = (personBUID) => async (dispatch) => {
  try {
    if (!personBUID) {
      console.error(`Action: getPersonalInformation. Error: Invalid 'Person bUID'`);
      return false;
    }

    const response = await http.post(`${appConfig.SSP_MID_URL}/getPersonalInformation`, {
      personBUID: personBUID,
    });

    if (!response || response.status !== 200) {
      dispatch(SET_ALERT_MESSAGE({
        type: 'error',
        errorCode: response?.status || '520',
        id: 'getPersonalInformation',
        show: false,
      }));
      return false;
    }

    const { data } = response;

    if (!data) {
      return false;
    }

    dispatch(
      onLoadAPI({
        PersonalInformation: data,
        isAPICallInProgress: false,
      })
    );
    dispatch(SET_EMPLOYEE_PROFILE(data.personalInformation));

    return response;
  } catch (error) {
    return false;
  }
};
